module.exports = __webpack_public_path__ + "img/transport.e749720c.svg";